/**
 * Finance Module
 * Comprehensive financial management, budgeting, and accounting system
 */

import React from 'react';
import type { RouteObject } from 'react-router-dom';
import type { Module } from '../../../index';
import Layout from '../../../components/Layout';
import PrivateRoute from '../../../components/PrivateRoute';

// Placeholder - to be implemented
const FinancePage: React.FC = () => <div>Finance Module - Coming Soon</div>;

const financeModule: Module = {
  name: 'finance',
  path: '/app/finance',
  routes: [
    {
      path: '/app/finance',
      element: <PrivateRoute><Layout /></PrivateRoute>,
      children: [
        {
          index: true,
          element: <FinancePage />
        }
      ]
    }
  ]
};

export default financeModule;

